import { ClerkProvider, SignedIn, SignedOut } from '@clerk/nextjs';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';
import type { ComponentType, ReactNode } from 'react';
import { HomePage } from '@/code/frontend/components/booking-ui';
import { AuthQueryBoundary } from '@/code/frontend/components/providers/AuthQueryBoundary';
import { NextPageWithLayout } from './_app';

// Client-only: the SignedOut landing skips DefaultLayout, so visitors don't
// download the dashboard bundle.
const DefaultLayoutShell = dynamic(
  () =>
    // @ts-expect-error nodenext can't resolve @/ in dynamic import(); webpack does.
    import('@/code/frontend/components/DefaultLayout').then(
      (mod): ComponentType<{ children: ReactNode; fixHeader?: boolean }> =>
        mod.DefaultLayoutShell,
    ),
  { ssr: false },
);

interface IndexPageProps {
  isEmployeeDeployment: boolean;
}

const IndexPage: NextPageWithLayout<IndexPageProps> = ({
  isEmployeeDeployment,
}) => {
  return <HomePage isEmployeeDeployment={isEmployeeDeployment} />;
};

IndexPage.getLayout = (page) => (
  <ClerkProvider>
    <AuthQueryBoundary>
      {/* Unauthenticated: full-screen landing with centered logo, no nav header */}
      <SignedOut>{page}</SignedOut>
      {/* Authenticated: DefaultLayout with nav header (redirect happens via HomePage) */}
      <SignedIn>
        <DefaultLayoutShell fixHeader>{page}</DefaultLayoutShell>
      </SignedIn>
    </AuthQueryBoundary>
  </ClerkProvider>
);

// DEPLOYMENT_TYPE is build-time (app vs employee are separate builds), so this
// page is fully static — no request-time work, no serverless cold start.
export const getStaticProps: GetStaticProps<IndexPageProps> = async () => {
  return {
    props: {
      isEmployeeDeployment: process.env.DEPLOYMENT_TYPE === 'employee',
    },
  };
};

export default IndexPage;
